__turbopack_context__.v({
  "highlight-pulse": "useScrollToHighlight-module__51G37W__highlight-pulse",
  "highlightPulse": "useScrollToHighlight-module__51G37W__highlightPulse",
});
